<template>
  <div class="login flex-center">
    <v-card class="modal modal-round">

      <div class="logo-wrapper flex-center">
        <img src="/images/logo.svg"
             alt="wifeed-logo"
             class="logo">
      </div>

      <h1>
        Link inválidado com sucesso!
      </h1>

    </v-card>

  </div>
</template>

<script>

    export default {
        components: {
        },
        data() {
            return {
            }
        },

        
        computed: {

        },

        created() {
            this.checkHash();

           
        },

        methods: {
            async checkHash() {
              try {
                 await this.$api.accountRecovery.invalidateRecovery({
                  hash:  this.$route.query.hash
                })
                 
              } catch (error) {
                console.log(error)
              }

              
            }
        }
    }
</script>

<style lang="scss" scoped>
@import "~@variables";

.login {
  width: 100vw;
  height: 100vh;
  background: $primary;

  .modal {
    min-width: 500px;
    padding: 42px;

    .logo-wrapper {
      width: 100%;
      margin-bottom: 42px;

      .logo {
        max-width: 197px;
        height: auto;
      }
    }
  }
}
</style>
